import Request from "@/common/net/request.js";
const request = new Request();
// 获取列表
export function getPage(data) {
  return request.send({
    url: `/pmy/sys/apk/page`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}
// 添加
export function addInfo(data) {
  return request.send({
    url: `/pmy/sys/apk`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}

// 编辑
export function editInfo(data) {
  return request.send({
    url: `/pmy/sys/apk`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}

// 删除
export function deleteInfo(apkId) {
  return request.send({
    url: `/pmy/sys/apk?apkId=${apkId}`,
    method: "delete",
  });
}
// 启用 警用
export function enableapk(data) {
  return request.send({
    url: `/pmy/sys/apk/status`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}
// 详情
export function detailInfo(apkId) {
  return request.send({
    url: `/pmy/sys/apk?apkId=${apkId}`,
    method: "get",
  });
}

// xiala
export function getapkList(apkId) {
  return request.send({
    url: `/pmy/sys/apk/list`,
    method: "get",
  });
}
